import {
  describeProblem,
  type Problem,
  type ProblemAsk,
} from "./describe-problem";
import { useProblemScope } from "./problem-scope";
import { requestBugReport } from "@/lib/support/bug-report-request";

/**
 * A failure said for the screen it is on: `describeProblem` with the ids of the scopes around
 * it, and the act that opens its report.
 */
export function useProblem(
  error: unknown,
  ask: ProblemAsk,
): { problem: Problem; report: () => void } {
  const scope = useProblemScope();
  const problem = describeProblem(error, {
    ...ask,
    report: { ...scope, ...ask.report },
  });
  return {
    problem,
    report: () => {
      requestBugReport(problem.report);
    },
  };
}
